export default (value) =>
  value >= 1
    ? {
        val: value,
        unit: "km",
        singular: "Kilometer",
        plural: "Kilometers",
      }
    : {
        val: value * 1000,
        unit: "m",
        singular: "Meter",
        plural: "Meters",
      };
